import { PersonMenuItemKey } from '../../constants/personMenuItemKeys';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

const initialState = {
  open: false,
  personId: null,
  savedCount: 0,
  requestId: null,
  closeOnSave: false,
  origin: null,
  initialMenuKey: PersonMenuItemKey.PERSON_DETAILS,
  savedResult: null,
  dialogs: [],
};

const PersonDialogReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_DIALOG_ACTION_TYPES.SHOW_ADD_EDIT_PERSON: {
      const dialog = {
        personId: action.payload.personId,
        requestId: action.payload.requestId,
        closeOnSave: Boolean(action.payload.closeOnSave),
        origin: action.payload.origin ?? null,
        initialMenuKey: action.payload.initialMenuKey ?? PersonMenuItemKey.PERSON_DETAILS,
      };
      return {
        ...state,
        ...dialog,
        open: true,
        dialogs: [...state.dialogs, dialog],
        savedResult: null,
      };
    }

    case USER_DIALOG_ACTION_TYPES.HIDE_ADD_EDIT_PERSON: {
      const topDialog = state.dialogs[state.dialogs.length - 1];
      const requestId = action.payload?.requestId;
      if (requestId && topDialog?.requestId !== requestId) return state;

      const dialogs = state.dialogs.slice(0, -1);
      const previousDialog = dialogs[dialogs.length - 1];
      return {
        ...state,
        open: dialogs.length > 0,
        personId: previousDialog?.personId ?? null,
        requestId: previousDialog?.requestId ?? null,
        closeOnSave: previousDialog?.closeOnSave ?? false,
        origin: previousDialog?.origin ?? null,
        initialMenuKey: previousDialog?.initialMenuKey ?? PersonMenuItemKey.PERSON_DETAILS,
        dialogs,
      };
    }

    case USER_DIALOG_ACTION_TYPES.PERSON_SAVED:
      return {
        ...state,
        savedCount: state.savedCount + 1,
        savedResult: action.payload || null,
      };

    default:
      return state;
  }
};

export default PersonDialogReducer;
